export default [
  {
    path: 'user/:id',
    name: 'user',
    component: () => import('@/views/pages/user/users-list/UsersView.vue'),
    meta: {
      pageTitle: 'Users',
      breadcrumb: [
        {
          to: { name: 'users' },
          text: 'Users',
          active: false,
        },
        {
          text: 'User',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
